import React from "react";

export default function Footer() {
  return (
    <div>
      {/* Footer Start */}
      <div className="container-fluid bg-dark text-light footer pt-5 mt-5 wow fadeIn" data-wow-delay="0.1s">
        <section className="container py-5">
          <div className="row g-5">
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-3">Şirket</h4>
              <a className="btn btn-link" href="/">
                Hakkımızda
              </a>
              <a className="btn btn-link" href="/">
                İletişim
              </a>
              <a className="btn btn-link" href="/">
                Gizlilik Politikası
              </a>
              <a className="btn btn-link" href="/">
                Şartlar ve Koşullar
              </a>
              <a className="btn btn-link" href="/">
                SSS ve Yardım
              </a>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-3">İletişim</h4>
              <p className="mb-2">
                <i className="fa fa-map-marker-alt me-3" />
                123 Sokak, New York, ABD
              </p>
              <p className="mb-2">
                <i className="fa fa-phone-alt me-3" />
                +012 345 67890
              </p>
              <p className="mb-2">
                <i className="fa fa-envelope me-3" />
                info@example.com
              </p>
              <div className="d-flex pt-2">
                <a className="btn btn-outline-light btn-social" href="/">
                  <i className="fab fa-twitter" />
                </a>
                <a className="btn btn-outline-light btn-social" href="/">
                  <i className="fab fa-facebook-f" />
                </a>
                <a className="btn btn-outline-light btn-social" href="">
                  <i className="fab fa-youtube" />
                </a>
                <a className="btn btn-outline-light btn-social" href="">
                  <i className="fab fa-linkedin-in" />
                </a>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-3">Galeri</h4>
              <div className="row g-2 pt-2">
                <div className="col-4">
                  <img className="img-fluid bg-light p-1" src="assets/img/package-1.jpg" alt="" />
                </div>
                <div className="col-4">
                  <img className="img-fluid bg-light p-1" src="assets/img/package-2.jpg" alt="" />
                </div>
                <div className="col-4">
                  <img className="img-fluid bg-light p-1" src="assets/img/package-3.jpg" alt="" />
                </div>
                <div className="col-4">
                  <img className="img-fluid bg-light p-1" src="assets/img/package-2.jpg" alt="" />
                </div>
                <div className="col-4">
                  <img className="img-fluid bg-light p-1" src="assets/img/package-3.jpg" alt="" />
                </div>
                <div className="col-4">
                  <img className="img-fluid bg-light p-1" src="assets/img/package-1.jpg" alt="" />
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-3">Bülten</h4>
              <p>Dolor amet sit justo amet elitr clita ipsum elitr est.</p>
              <div className="position-relative mx-auto" style={{ maxWidth: 400 }}>
                <input className="form-control border-primary w-100 py-3 ps-4 pe-5" type="text" placeholder="E-posta adresiniz" />
                <button type="button" className="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2">
                  Kayıt Ol
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="container">
          <div className="copyright">
            <div className="row">
              <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                ©{" "}
                <a className="border-bottom" href="#">
                  Sitenizin Adı
                </a>
                , Tüm Hakları Saklıdır. Tasarım{" "}
                <a className="border-bottom" href="https://github.com/ParasSalunke">
                  Paras Salunke
                </a>
              </div>
              <div className="col-md-6 text-center text-md-end">
                <div className="footer-menu">
                  <a href="/">Ana Sayfa</a>
                  <a href="/">Çerezler</a>
                  <a href="/">Yardım</a>
                  <a href="/">SSS</a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* Footer End */}
    </div>
  );
}
